import React from 'react';
import Icon from '../../../components/AppIcon';

const NeighborhoodInfo = ({ location, coordinates }) => {
  const amenities = [
    { icon: 'ShoppingCart', label: 'Supermarchés', count: 5, distance: '500m' },
    { icon: 'GraduationCap', label: 'Écoles', count: 3, distance: '1km' },
    { icon: 'Hospital', label: 'Hôpitaux', count: 2, distance: '2km' },
    { icon: 'Bus', label: 'Transports', count: 8, distance: '200m' },
    { icon: 'Coffee', label: 'Restaurants', count: 12, distance: '300m' },
    { icon: 'Dumbbell', label: 'Fitness', count: 2, distance: '800m' }
  ];

  const safetyScore = 85;
  const walkabilityScore = 78;
  const transitScore = 92;

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-xl md:text-2xl font-semibold text-white mb-4">
          Informations sur le quartier
        </h3>
        <p className="text-slate-400">
          Découvrez les commodités et services disponibles autour de {location}
        </p>
      </div>
      <div className="aspect-video rounded-lg overflow-hidden shadow-2xl">
        <iframe
          width="100%"
          height="100%"
          loading="lazy"
          title={`Map of ${location}`}
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps?q=${coordinates?.lat},${coordinates?.lng}&z=14&output=embed`}
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-green-500/10 rounded-lg p-4 border border-green-500/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-medium text-white">Sécurité</span>
            <Icon name="Shield" size={20} className="text-green-400" />
          </div>
          <div className="flex items-end gap-2">
            <span className="text-3xl font-bold text-green-400">{safetyScore}</span>
            <span className="text-sm text-slate-400 mb-1">/100</span>
          </div>
          <div className="w-full bg-slate-800 rounded-full h-2 mt-2">
            <div
              className="bg-green-500 rounded-full h-2 transition-all duration-500"
              style={{ width: `${safetyScore}%` }}
            />
          </div>
        </div>

        <div className="bg-blue-500/10 rounded-lg p-4 border border-blue-500/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-medium text-white">Marchabilité</span>
            <Icon name="Footprints" size={20} className="text-blue-400" />
          </div>
          <div className="flex items-end gap-2">
            <span className="text-3xl font-bold text-blue-400">{walkabilityScore}</span>
            <span className="text-sm text-slate-400 mb-1">/100</span>
          </div>
          <div className="w-full bg-slate-800 rounded-full h-2 mt-2">
            <div
              className="bg-blue-500 rounded-full h-2 transition-all duration-500"
              style={{ width: `${walkabilityScore}%` }}
            />
          </div>
        </div>

        <div className="bg-amber-500/10 rounded-lg p-4 border border-amber-500/20">
          <div className="flex items-center justify-between mb-2">
            <span className="text-sm font-medium text-white">Transports</span>
            <Icon name="Bus" size={20} className="text-amber-400" />
          </div>
          <div className="flex items-end gap-2">
            <span className="text-3xl font-bold text-amber-400">{transitScore}</span>
            <span className="text-sm text-slate-400 mb-1">/100</span>
          </div>
          <div className="w-full bg-slate-800 rounded-full h-2 mt-2">
            <div
              className="bg-amber-500 rounded-full h-2 transition-all duration-500"
              style={{ width: `${transitScore}%` }}
            />
          </div>
        </div>
      </div>
      <div>
        <h4 className="text-lg font-semibold text-white mb-4">
          Commodités à proximité
        </h4>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {amenities?.map((amenity, index) => (
            <div key={index} className="bg-slate-800/40 backdrop-blur-xl border border-white/10 rounded-lg p-4 hover:shadow-2xl transition-shadow">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-blue-500/10 flex items-center justify-center flex-shrink-0">
                  <Icon name={amenity?.icon} size={20} className="text-blue-400" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="font-medium text-white">{amenity?.label}</p>
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-sm text-slate-400">{amenity?.count} disponibles</span>
                    <span className="text-xs text-slate-400">•</span>
                    <span className="text-sm text-amber-400">{amenity?.distance}</span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="bg-slate-800/50 rounded-lg p-6">
        <div className="flex items-start gap-3">
          <Icon name="MapPin" size={24} className="text-blue-400 mt-1" />
          <div>
            <h4 className="text-lg font-semibold text-white mb-2">
              À propos de {location}
            </h4>
            <p className="text-sm text-slate-400 leading-relaxed">
              {location} est un quartier dynamique de Kinshasa, offrant un excellent équilibre entre vie urbaine et tranquillité résidentielle. Avec ses nombreuses commodités, ses bonnes connexions de transport et son environnement sécurisé, c'est un choix idéal pour les familles et les professionnels.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NeighborhoodInfo;
